module.exports = __webpack_public_path__ + "img/cases-brand-tommee-0.39b584b6.jpg";